import { render, staticRenderFns } from "./WeeklyReportViewTransfers.vue?vue&type=template&id=30477ade"
import script from "./WeeklyReportViewTransfers.vue?vue&type=script&lang=js"
export * from "./WeeklyReportViewTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports